module.exports = __webpack_public_path__ + "static/media/movies.8607f08a.svg";